import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";


function BeDistributor() {
    const navigate = useNavigate();

    const initialFormStateDistributor = { full_name: '', email: '', phone_no: '', space_available: '', initial_investment: '', created_date: new Date() }
    const [submitDistributor, setSubmitDistributor] = useState(initialFormStateDistributor)

    const [show, setshow] = useState(true);


    const handleChangeDistributor = (e) => {
        const { id, value } = e.target
        setSubmitDistributor({ ...submitDistributor, [id]: value })
    }

    const handleSubmitDistributor = (e) => {
        // alert(submitDistributor.phone_no.length)
        console.log(JSON.stringify(submitDistributor));
        e.preventDefault();

        db.collection("product_distributor").add({
            name: submitDistributor.full_name,
            phone_no: submitDistributor.phone_no,
            email: submitDistributor.email,
            space_available: submitDistributor.space_available,
            initial_investment: submitDistributor.initial_investment,
            created_date: submitDistributor.created_date,
            uid: "",
        })
            .then(() => {
                console.log('Added successfull');
                const Toast = Swal.mixin({
                    toast: true,
                    background: '#69aba6',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'success',
                    title: 'Thank you for your interest ! We will get in touch with you'
                })
                setSubmitDistributor({ full_name: '', email: '', phone_no: '', space_available: '', initial_investment: '', created_date: new Date() })
            });


    }

    const clearForm = () => {
        setSubmitDistributor({ full_name: '', email: '', phone_no: '', address: '', course: '', duration: '', timing: "", days: "", fee_proposed: "", mode: '', course_content: '', student_count: '', need_certificate: '', starting_date: '', created_date: new Date() });
    }
    // const handleChange = (e) => {
    //     const { id, value } = e.target
    //     setSubmit({ ...submit, [id]: value })
    // }

    // const reset = () => {
    //     setSubmit({ parlour_name: '', phone_no: '', email: '', pincode: '', place: '', plus_code: '', username: '', full_address: '', usercode: '', created_date: new Date() })
    // }

    // const ids = ["rahul_122002", "ashutosh_560001", "mrinal_122004"];
    // const handleSubmit = (e) => {
    //     console.log(submit.usercode)
    //     e.preventDefault()

    //     if (ids.includes(submit.usercode)) {
    //         const file = e.target[0]?.files[0]
    //         // console.log(file)
    //         if (!file) return;
    //         const storageRef = ref(storage, `files/${file.name}`);
    //         const uploadTask = uploadBytesResumable(storageRef, file);
    //         setshow(false)

    //         uploadTask.on("state_changed",
    //             (snapshot) => {
    //                 const progress =
    //                     Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //                 setProgresspercent(progress);
    //             },
    //             (error) => {
    //                 alert(error);
    //             },
    //             () => {
    //                 getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                     // setImgUrl(downloadURL)
    //                     db.collection("unregistered_users").add({
    //                         'parlour_name': submit.parlour_name,
    //                         'phone_no': submit.phone_no,
    //                         'pincode': submit.pincode,
    //                         'place_best_beauty_parlour_in': submit.place,
    //                         'full_address': submit.full_address,
    //                         'rating': '',
    //                         'reviews': '',
    //                         'image': downloadURL,
    //                         'username': submit.username,
    //                         'plus_code': submit.plus_code,
    //                         'email': submit.email,
    //                         'usercode': submit.usercode,
    //                         'monday': '',
    //                         'tuesday': '',
    //                         'wednesday': '',
    //                         'thursday': '',
    //                         'friday': '',
    //                         'saturday': '',
    //                         'sunday': '',
    //                         'created_date': new Date(),
    //                     }).then(() => {
    //                         reset();
    //                         setshow(true)
    //                         console.log('Added Successfully');
    //                         const Toast = Swal.mixin({
    //                             toast: true,
    //                             background: '#69aba6',
    //                             position: 'top-end',
    //                             showConfirmButton: false,
    //                             timer: 3000,
    //                             timerProgressBar: true,
    //                             didOpen: (toast) => {
    //                                 toast.addEventListener('mouseenter', Swal.stopTimer)
    //                                 toast.addEventListener('mouseleave', Swal.resumeTimer)
    //                             }
    //                         })

    //                         Toast.fire({
    //                             icon: 'success',
    //                             title: 'Beauty Parlour Added'
    //                         })
    //                         navigate(`/${submit.username}`);
    //                     })
    //                 });
    //             }
    //         );
    //     } else {
    //         alert("usercode does not exist")
    //     }

    // }



    return (

        <>
            {/* <div id="small-dialog" class="">
                <div class="w3layouts_payment_online_form">
                    <form action="#" method="post">
                        <h4>Account Info</h4>
                        <ul>
                            <li><input class="w3l_text_box" placeholder="First Name" name="First Name" type="text" required="" />
                            </li>
                            <li><input class="w3l_text_box" placeholder="Last Name" name="Last Name" type="text" required="" />
                            </li>
                        </ul>
                        <ul>
                            <li><input class="w3l_text_box" placeholder="Email" name="Email" type="email" required="" /></li>
                            <li><input class="w3l_text_box" placeholder="Phone Number" name="Phone" type="text" required="" />
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <label>No of Persons</label>
                                <select class="form-control">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="6">More</option>
                                </select>
                            </li>
                            <li>
                                <label>Space available to stock product</label>
                                <select class="form-control">
                                    <option value="1">John Mark</option>
                                    <option value="2">Michael Lii</option>
                                    <option value="3">Gambriel</option>
                                    <option value="4">Laura Carl</option>
                                </select>
                            </li>
                        </ul>
                        <ul>
                            <li class="w3ls_address"><input class="w3l_text_box" placeholder="Address" name="Address"
                                type="text" required="" /></li>
                        </ul>
                        <ul class="w3_payment_sendbtns">
                            <li><input type="reset" value="Reset" /></li>
                            <li><input type="submit" value="Request Appointment" /></li>
                        </ul>
                        <div class="clearfix"> </div>
                    </form>
                </div>
            </div> */}
            <div id="small-dialog" class="m-3">
                <div class="w3layouts_payment_online_form">
                    <form class="" id="" onSubmit={handleSubmitDistributor}>
                        <h4>Be A Beauty Products Distributor</h4>
                        <ul>
                            <li><input class="w3l_text_box" id="full_name" onChange={handleChangeDistributor} value={submitDistributor.full_name} placeholder="Full Name" name="Full Name" type="text" required />
                            </li>
                            <li><input class="w3l_text_box" id="phone_no" onChange={handleChangeDistributor} value={submitDistributor.phone_no} placeholder="10 Digit Phone Number" name="Phone" type="tel" minlength="10" maxlength="10" required />
                            </li>
                        </ul>
                        <ul>
                            <li><input class="w3l_text_box" id="email" onChange={handleChangeDistributor} value={submitDistributor.email} placeholder="Email" name="Email" type="email" required="" /></li>
                            <li>
                                <input class="w3l_text_box" id="initial_investment" onChange={handleChangeDistributor} value={submitDistributor.initial_investment} placeholder="Initial Investment" name="Initial Investment" type="number" required />
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <label>Space available to stock product</label>
                                <select class="form-control" onChange={handleChangeDistributor} id="space_available" required>
                                    <option value="">--Select--</option>
                                    <option value="Yes">Yes</option>
                                    <option value="NO">NO</option>
                                </select>
                            </li>
                            <li></li>
                        </ul>
                        <ul class="w3_payment_sendbtns">
                            <li><input type="reset" value="Cancel" onClick={() => navigate(`/quicklinks`)} /></li>
                            <li class='mr-4'><input type="reset" data-dismiss="modal" aria-label="Close" onClick={clearForm} value="Reset" /></li>
                            <li><input type="submit" value="Submit" /></li>
                        </ul>
                        <div class="clearfix"> </div>
                    </form>
                </div>
            </div>
        </>


    );
}
export default BeDistributor;